import React, { useState, useEffect } from "react";
import "./emp-schedule.css";
import { FaUsers } from "react-icons/fa6";
import { FaUserClock } from "react-icons/fa";
import { IoEye } from "react-icons/io5";
import { Col, Dropdown, Button, Form, Modal, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from '../../Authservices/axiosInstance';
import { IoMdAdd } from "react-icons/io";
import { FaRegEdit } from "react-icons/fa";

export default function EmpsSchedule() {
  const navigate = useNavigate();

  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [empData, setEmpData] = useState([]);
  const [timingData, setTimingData] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch employees
  useEffect(() => {
    const fetchEmployees = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await axios.get("https://backend.ems.hiradentallab.com/api/user/getAllUsers");
        setEmpData(response.data);
        await fetchTimingData();
      } catch (error) {
        console.error("Error fetching employees:", error);
        setError("Failed to load employee data.");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployees();
  }, []);

  // Fetch timing data
  const fetchTimingData = async () => {
    try {
      const response = await axios.get("https://backend.ems.hiradentallab.com/api/timings/getAllTimings");
      const timings = response.data.reduce((acc, timing) => {
        acc[timing.userId] = timing;
        return acc;
      }, {});
      setTimingData(timings);
    } catch (error) {
      console.error("Error fetching timing data:", error);
      setError("Failed to load timing data.");
    }
  };

  // Filter data based on search query
  const filteredData = empData.filter((employee) =>
    employee.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalEntries = filteredData.length;
  const totalPages = Math.ceil(totalEntries / rowsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleViewClick = (employee) => {
    setSelectedEmp(employee);
    setShowModal(true);
  };

  const handleAddClick = (employee) => {
    navigate(`/emps-timing/${employee.userId}`, {
      state: { selectedUserId: employee.userId, shift: timingData[employee.userId]?.shift },
    });
  };

  const handleEditClick = (employee) => {
    navigate(`/edit-timing/${employee.userId}`, {
      state: { selectedUserId: employee.userId, shift: timingData[employee.userId]?.shift },
    });
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedEmp(null);
  };

  return (
    <div className="container-fluid">
      <h1 className="emps-schedule-title">
        <FaUserClock /> Employee Schedule
      </h1>
      <hr />
      <h1 className="emps-schedule-subtitle">
        <FaUsers /> Employees
      </h1>
      <hr />
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="emps-schedule-content">
        <div className="filter-container">
          <Col xs={12} md={6} className="filter-left">
            <Dropdown className="d-inline mx-2" autoClose="inside">
              <Dropdown.Toggle id="dropdown-autoclose-inside">
                Show Entries
              </Dropdown.Toggle>
              <Dropdown.Menu className="custom-dropdown-menu">
                <Dropdown.Item href="#">15</Dropdown.Item>
                <Dropdown.Item href="#">25</Dropdown.Item>
                <Dropdown.Item href="#">50</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
          <Col xs={12} md={6} className="filter-right">
            <Form>
              <Form.Control
                type="search"
                placeholder="Search by Name"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="depts-search-bar"
              />
            </Form>

          </Col>
        </div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped">
              <thead className="table-header">
                <tr className="emps-schedule-table-header">
                  <th>SR</th>
                  <th>UserId</th>
                  <th>Employee Name</th>
                  <th>Department</th>
                  <th>Shift</th>
                  <th>Check-In Time</th>
                  <th>Check-Out Time</th>
                  <th>Working Hours</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((employee, index) => {
                    const timingDetails = timingData[employee.userId] || {};
                    return (
                      <tr key={employee._id}>
                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                        <td>{employee.userId}</td>
                        <td>{employee.name}</td>
                        <td>{employee.department?.name || "N/A"}</td>
                        <td>{timingDetails.shift || "-"}</td>
                        <td>{timingDetails.shiftStart || "-"}</td>
                        <td>{timingDetails.shiftEnd || "-"}</td>
                        <td>{timingDetails.totalHours || "-"}</td>
                        <td>
                          <Button
                          variant="success"
                            size="sm"
                            onClick={() => handleAddClick(employee)}
                          >
                            <IoMdAdd />
                          </Button>
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => handleViewClick(employee)}
                          >
                            <IoEye />
                          </Button>
                          <Button
                            variant="warning"
                            size="sm"
                            onClick={() => handleEditClick(employee)}
                            style={{marginLeft:'8px'}}
                          >
                            <FaRegEdit />
                          </Button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" style={{ textAlign: "center" }}>
                      No employee data available.
                    </td>
                  </tr>
                )}
              </tbody>
              <tfoot className="table-footer">
                <tr className="hr-schedule-table-footer">
                  <td>Total</td>
                  <td>-</td>
                  <td>{totalEntries}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
       <div className="entries-pagination-container">
          <p>
            Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
            {Math.min(currentPage * rowsPerPage, totalEntries)} of {totalEntries} entries
          </p>
          <nav>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </button>
              </li>
              {[...Array(totalPages).keys()].map((page) => (
                <li
                  key={page + 1}
                  className={`page-item ${currentPage === page + 1 ? "active" : ""}`}
                >
                  <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                    {page + 1}
                  </button>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                <button
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Employee Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEmp && (
            <div>
              <h4>Name: {selectedEmp.name}</h4>
              <p>UserId: {selectedEmp.userId}</p>
              <p>Department: {selectedEmp.department?.name || "N/A"}</p>
              <p>Shift: {timingData[selectedEmp.userId]?.shift || "N/A"}</p>
              <p>Check-In Time: {timingData[selectedEmp.userId]?.shiftStart || "N/A"}</p>
              <p>Check-Out Time: {timingData[selectedEmp.userId]?.shiftEnd || "N/A"}</p>
              <p>Break-In: {timingData[selectedEmp.userId]?.breakStart|| "N/A"}</p>
              <p>Break-Out: {timingData[selectedEmp.userId]?.breakEnd || "N/A"}</p>
              <p>Working Hours: {timingData[selectedEmp.userId]?.totalHours || "N/A"}</p>

            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
